exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.price-original[data-v-41e91b1a] {\n  text-decoration: line-through;\n}\n.product-image[data-v-41e91b1a] {\n  margin-right: 16px;\n&.image {\n    mix-blend-mode: multiply;\n    vertical-align: top;\n    width: 150px;\n    padding-bottom: calc(100% - 16px);\n}\n@media only screen and (max-width: 576px) {\n    margin-right: 8px;\n}\n}\n.text-left[data-v-41e91b1a]{\n  text-align: left;\n}\n", ""]);

// exports
